import { render, staticRenderFns } from "./AdsComments.vue?vue&type=template&id=c76e199e&scoped=true&"
import script from "./AdsComments.vue?vue&type=script&lang=js&"
export * from "./AdsComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76e199e",
  null
  
)

export default component.exports